import { flip$ } from '@/shared/assets/tokens';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import useTokenPrice from '@/shared/hooks/useTokenPrice';
import FlipAmount from '@/shared/utils/FlipAmount';
import type TokenAmount from '@/shared/utils/TokenAmount';
import getLatestFlipSupplyQuery from '../graphql/cache/flipSupplyQueries';

interface FlipSupplyHook {
  totalFlipSupply: string | undefined;
  annualSystemCompoundedRewards: TokenAmount | undefined;
  annualSystemCompoundedRewardsValueUsd: string | undefined;
  isLoading: boolean;
  error: Error | undefined;
}

const useFlipSupply = (): FlipSupplyHook => {
  const { price: flipUsdcPrice = 0 } = useTokenPrice(flip$);
  const { isLoading, error, data } = useGqlQuery(getLatestFlipSupplyQuery, {
    context: { clientName: 'statechainCache' },
  });
  const flipSupply = data?.flipSupply;
  const totalFlipSupply = FlipAmount.from(flipSupply?.totalIssuance);

  const annualSystemCompoundedRewards =
    FlipAmount.from(flipSupply?.annualSystemCompoundedRewards) ?? undefined;

  return {
    totalFlipSupply: totalFlipSupply?.toFormatted('numeral'),
    annualSystemCompoundedRewards,
    annualSystemCompoundedRewardsValueUsd: annualSystemCompoundedRewards
      ?.toBigNumber()
      .multipliedBy(flipUsdcPrice)
      .toString(),
    isLoading,
    error: error ?? undefined,
  };
};

export default useFlipSupply;
